// extracted by mini-css-extract-plugin
export default {"table":"Orders_table__SZUVZ","icons":"Orders_icons__BK7HH","pending":"Orders_pending__JhqoB","delivered":"Orders_delivered__8tT+J"};